<template>
  <RealisasiKpiKorporatForm mode="Ubah" module="Realisasi Indikator Kinerja"> </RealisasiKpiKorporatForm>
</template>

<script>
import RealisasiKpiKorporatForm from './form-realisasi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const RealisasiKpiKorporatUpdate = {
  name: 'RealisasiKpiKorporatUpdate',
  components: { RealisasiKpiKorporatForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default RealisasiKpiKorporatUpdate;
</script>
